import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import buildRequestUrlToFetchSearchDataFromAgatha from "@/search/buildRequestUrlToFetchSearchDataFromAgatha";

const useLazyAgathaFetchQuery = ({ endpoint, queryParameters }) => {
  const requestUrl = buildRequestUrlToFetchSearchDataFromAgatha({
    endpoint,
    queryParameters,
  });

  return useLazyRestQuery(requestUrl);
};

export default useLazyAgathaFetchQuery;
